export default __webpack_public_path__ + "static/media/about-team-ada-dong.f761d917.png";